export const useTableHelper = {
  methods: {
    getRowLink(item, link) {
      const foreignKey = `${link}_id`
      const component = item[foreignKey]
      if (component) {
        const rowLink = `/${link}s/${component['id']}`
        return rowLink
      }
    },
    getRow(value, maxLimit = 24) {
      if (typeof value === 'boolean') {
        return value ? '✓' : '✖'
      }
      if (value === 0) {
        return value;
      }
      if (!value) {
        return '-';
      }
      if (value.length >= maxLimit) {
        const lastSymbolIndex = maxLimit - 1
        return `${value.substring(0, lastSymbolIndex)}...`
      }
      return value
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/useTableHelper.js